<template>
  <a class="rs-listing__card" :href="post.tribute_source_url">
    <div class="rs-listing__card__image">
      <div v-if="post.featured_image" v-html="post.featured_image"></div>
    </div>
    <div class="rs-listing__card__categories">
      <span v-for="(tribute_category, i) in post.rs_tribute_category" :key="tribute_category.slug">
        <span v-if="i > 0">, </span>
        <a :href="tribute_category.permalink" v-html="tribute_category.name"></a>
      </span>
    </div>
    <div class="rs-listing__card__title" v-html="post.post_title"></div>
    <div class="rs-listing__card__description" v-html="post.tribute_source_name"></div>
    <div class="rs-listing__card__footer">
      <div class="rs-listing__card__footer__cta">
        <span>Open Link</span>
        <svg 
          width="16"
          height="16"
          viewBox="0 0 16 16"
        >
          <path
            d="M15.55-14l-5.1.005a.45.45,0,0,0-.45.45V-12.5h0a.45.45,0,0,0,.45.45h.009l2.3-.085.064.064L4.11-3.36A.374.374,0,0,0,4-3.094a.374.374,0,0,0,.11.266l.719.719A.374.374,0,0,0,5.094-2a.374.374,0,0,0,.266-.11l8.714-8.715.064.064-.085,2.3s0,.006,0,.009A.45.45,0,0,0,14.5-8h1.041a.45.45,0,0,0,.45-.45L16-13.55A.45.45,0,0,0,15.55-14ZM13.5-5H13a.5.5,0,0,0-.5.5V.312A.188.188,0,0,1,12.312.5H1.687A.188.188,0,0,1,1.5.312V-10.312a.188.188,0,0,1,.187-.187H6.5A.5.5,0,0,0,7-11v-.5a.5.5,0,0,0-.5-.5h-5A1.5,1.5,0,0,0,0-10.5V.5A1.5,1.5,0,0,0,1.5,2h11A1.5,1.5,0,0,0,14,.5v-5A.5.5,0,0,0,13.5-5Z"
            transform="translate(0 14)"
            fill="#652981"
          />
        </svg>
      </div>
    </div>
  </a>
</template>

<script>
export default {
  props: {
    baseURL: String,
    post: Object,
  },
};
</script>
